import { render, staticRenderFns } from "./CryptoWalletCard.vue?vue&type=template&id=b70a06b0"
import script from "./CryptoWalletCard.vue?vue&type=script&lang=js"
export * from "./CryptoWalletCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports